export enum Challenges {
  enableMembersInvitation = 'specs.challenges.EnableMembersInvitation',
  showStepShare = 'specs.challenges.WebMemberShowStepShare',
  enableSlugsInUrl = 'specs.challenges.WebUseSlugsInURL',
  renderSeoTags = 'specs.challenges.WebEnableRenderSeoTags',
  enableChallengesPage = 'specs.challenges.OOIEnableChallengesPage',

  isRolesSection = 'specs.challenges.OOIEnableRolesInSP',
  isSidebarLayout = 'specs.challenges.OOIEnableSidebarLayout',
  isMAEnabled = 'specs.challenges.OOIEnableMA',
  isHiddenStepsEnabled = 'specs.challenges.OOIEnableHiddenAndLockSteps',
  muteErrorToastNotifications = 'specs.challenges.MuteErrorToastNotifications',
  enableConcurrentMode = 'specs.challenges.OOIEnableConcurrentMode',
  enableHappyScreens = 'specs.challenges.WebMemberHappyScreens',
  enableNewSidebarScrollingBehaviour = 'specs.challenges.WebNewSidebarScrollingBehaviour',
  enableFullscreenMode = 'specs.challenges.WebSidebarFullscreenMode',
}

export type ExperimentBoolean = 'true' | 'false';

export interface IChallengeExperiments {
  [index: string]: ExperimentBoolean;
  [Challenges.enableMembersInvitation]?: ExperimentBoolean;
  [Challenges.muteErrorToastNotifications]?: ExperimentBoolean;
  [Challenges.showStepShare]?: ExperimentBoolean;
  [Challenges.renderSeoTags]?: ExperimentBoolean;
  [Challenges.enableChallengesPage]?: ExperimentBoolean;
  [Challenges.isRolesSection]?: ExperimentBoolean;
  [Challenges.isSidebarLayout]?: ExperimentBoolean;
  [Challenges.isMAEnabled]?: ExperimentBoolean;
  [Challenges.isHiddenStepsEnabled]?: ExperimentBoolean;
  [Challenges.enableConcurrentMode]?: ExperimentBoolean;
  [Challenges.enableHappyScreens]?: ExperimentBoolean;
  [Challenges.enableFullscreenMode]?: ExperimentBoolean;
}
